import Helper from "./Helper";

class Highlights {
  constructor(config = {}) {
    const {
      container,
      title,
      toggler
    } = config;

    this.container = container;
    this.containers = Array.prototype.slice.call(document.querySelectorAll(container));

    this.title = title;

    this.trigger = toggler;
    this.triggers = Array.prototype.slice.call(document.querySelectorAll(toggler));

    if (this.triggers && this.triggers.length !== 0) {
      this.bindEvents();
      this.setHeight();

      if (window.location.hash) {
        this.scrollToHash();
      }
    }
  }

  bindEvents() {
    this.triggers.forEach(el => {
      el.addEventListener('click', (e) => {
        Helper.addClass(el, 'hidden');
        console.log(el.nextSibling);
        Helper.slideDown(el.nextElementSibling);
      });
    });
  }

  scrollToHash() {
    const item = document.querySelector(window.location.hash);
    if (!item) return;
    const header = document.querySelector('.header');
    const headerOffset = header.offsetHeight? header.offsetHeight : 0;
    const elementPosition = item.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY  - headerOffset;

    setTimeout(() => {
      window.scrollTo({
        top: (offsetPosition - 0),
        behavior: "smooth"
      });
    }, 1000);
  }

  setHeight() {
    this.containers.forEach(el => {
      let titleHeight = el.querySelector(this.title).offsetHeight;
      let containerHeight = el.offsetHeight;
      let totalHeight = 0;

      if (containerHeight > titleHeight) {
        totalHeight = containerHeight + 120;
      } else {
        totalHeight = titleHeight + 120;
      }
      el.style.minHeight = totalHeight + 'px';
    });
  }
}

export default Highlights;
